module.exports = __webpack_public_path__ + "assets/cde10bcc4ddf76fcb8ff5325125234c5.png";